import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import Logo from './components/Logo';
import HeroVideo from './components/HeroVideo';
import TopProducts from './components/TopProducts';
import TrustSection from './components/TrustSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import GuaranteeSection from './components/GuaranteeSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import OrderSuccess from './components/OrderSuccess';
import PremiumLanding from './components/PremiumLanding';
import ScrollToTop from './components/ScrollToTop';
import MetaPixel from './components/MetaPixel';
import ChatbotWidget from './ChatbotWidget';
import SeoHead from './components/SeoHead';
import { CartProvider } from './context/CartContext';
import { setupLazyLoading } from './utils/imageOptimization';
import { getSiteOrigin } from './config/site';
import ErrorBoundary from './components/ErrorBoundary';
import { mainProduct } from './data/product';
import './styles.css';
import './components/background-fix.css';

const HOME_DESC =
  'GOUNOD – професионални фитили и ленти за вдигане. Фитили RP Versa Grips style и Girlfriend version. Безплатна доставка при 2 или повече артикула, иначе до 3.99 €.';

const PREMIUM_DESC =
  'Фитили RP Versa Grips style от GOUNOD – висококачествени ленти с поддръжка за китки за мъртва тяга, набирания и силови тренировки. 19.99 €.';

function productImageAbsoluteUrl(origin, image) {
  if (typeof image !== 'string') return `${origin}/logo-gounod.png`;
  if (image.startsWith('http')) return image;
  return `${origin}${image.startsWith('/') ? image : `/${image}`}`;
}

function App() {
  useEffect(() => {
    setupLazyLoading();
  }, []);

  const homeJsonLd = useMemo(() => {
    const origin = getSiteOrigin();
    const logoUrl = `${origin}/logo-gounod.png`;
    return {
      '@context': 'https://schema.org',
      '@type': 'Store',
      name: 'GOUNOD',
      description: HOME_DESC,
      url: origin,
      logo: logoUrl,
      image: logoUrl,
      telephone: '+359879985171',
      email: 'ttashev16@gmail.com',
      priceRange: '€€',
      currenciesAccepted: 'EUR'
    };
  }, []);

  const premiumJsonLd = useMemo(() => {
    const origin = getSiteOrigin();
    const logoUrl = `${origin}/logo-gounod.png`;
    const mainImagePath = productImageAbsoluteUrl(origin, mainProduct.image);
    return {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Фитили RP Versa Grips style',
      description: PREMIUM_DESC,
      image: [mainImagePath, logoUrl],
      brand: { '@type': 'Brand', name: 'GOUNOD', logo: logoUrl },
      offers: {
        '@type': 'Offer',
        price: '19.99',
        priceCurrency: 'EUR',
        availability: 'https://schema.org/InStock',
        url: `${origin}/premium-strap`
      }
    };
  }, []);

  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <MetaPixel />
        <ErrorBoundary>
          <div>
            <Logo />
            <Routes>
              <Route path="/" element={
                <>
                  <SeoHead
                    title="GOUNOD – Фитили и ленти за вдигане"
                    description={HOME_DESC}
                    path="/"
                    jsonLd={homeJsonLd}
                  />
                  <HeroVideo />
                  <TopProducts />
                  <TrustSection />
                  <BenefitsSection />
                  <TestimonialsSection />
                  <GuaranteeSection />
                  <FAQ />
                </>
              } />
              <Route path="/premium-strap" element={
                <>
                  <SeoHead
                    title="Фитили RP Versa Grips style"
                    description={PREMIUM_DESC}
                    path="/premium-strap"
                    jsonLd={premiumJsonLd}
                    shareImage={productImageAbsoluteUrl(getSiteOrigin(), mainProduct.image)}
                  />
                  <PremiumLanding />
                </>
              } />
              <Route path="/cart" element={
                <>
                  <SeoHead
                    title="Количка"
                    description="Вашата количка с продукти GOUNOD."
                    path="/cart"
                    noindex
                  />
                  <Cart />
                </>
              } />
              <Route path="/checkout" element={
                <>
                  <SeoHead
                    title="Плащане"
                    description="Завършване на поръчка GOUNOD."
                    path="/checkout"
                    noindex
                  />
                  <Checkout />
                </>
              } />
              <Route path="/order-success" element={
                <>
                  <SeoHead
                    title="Поръчката е приета"
                    description="Потвърждение на поръчка."
                    path="/order-success"
                    noindex
                  />
                  <OrderSuccess />
                </>
              } />
            </Routes>
            <Footer />
            <ChatbotWidget />
          </div>
        </ErrorBoundary>
      </Router>
    </CartProvider>
  );
}

export default App;

